import React from "react";

/** Diagonal outgoing arrow (↗). Uses currentColor for stroke. */
export const OutgoingArrow = ({
  size = 18,
  className = "",
  direction = "up",
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    style={direction === "down" ? { transform: "scaleY(-1)" } : undefined}
  >
    <path
      d="M14.25 3.75L3.75 14.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.25 11.4525V3.75H6.5475"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default OutgoingArrow;
